import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { HelpComponent } from '../help/help.component';
import { IconButtonComponent } from '@shared/ui-components/icon-button/icon-button.component';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ac-help-trigger',
  standalone: true,
  imports: [MatMenuModule, HelpComponent, IconButtonComponent, IconComponent, TranslateModule],
  templateUrl: './help-trigger.component.html',
  styleUrl: './help-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpTriggerComponent {}
